module.exports = __webpack_public_path__ + "static/media/2020-nov-2.65bb3777.jpeg";